module.exports = __webpack_public_path__ + "img/Iraq-img.c49d7033.png";